import React, { Component } from 'react';
import Auxilary from '../../hoc/auxilary';
import Burger from '../../components/Burger/Burger';
import BuildControls from '../../components/Burger/BuildControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary';

const INGREDIENT_PRICES =
{
    lettuce: 0.10,
    cheese: 0.4,
    meat: 1.5,
    bacon: 0.7
}

class BurgerBuilder extends Component
{
    state = {
        ingredients:
        {
            lettuce:0,
            bacon:0,
            cheese:0,
            meat:0
        },
        totalPrice: 4,
        pruchasable: false,
        purchasing: false
    }

    // determing if we can click 'order now' based on if an ingredient has been selected
    updatePurchaseState = (ingredients) =>
    {
        // Object.keys transforms into an array of ingredients
        const sum = Object.keys(ingredients).map(igKey =>
            {// igKey will be each of our ingredients within the array
                return ingredients[igKey]; // we then grab the values assoicated with each ingredient (total number)
            }).reduce((sum, el) => // sum is what is saved each iteration. el is what is added to the sum each iteration
            {
                return sum + el;
            }, 0); // 0 being our starting number (sum will start at 0)
            console.log(sum)
            this.setState ({purchasable: sum > 0}) // if sum > 0, will return true, otherwise false
    }

    addIngredientHandler = (type) => 
    {
        const oldCount = this.state.ingredients [type];
        const updatedCount = oldCount + 1;
        
        // create a copy of te ingredients (prevent aliasing)
        let updatedIngredients = {
            ...this.state.ingredients
        };

        // update the new ingredient count within our copied ingredients object 
        updatedIngredients[type] = updatedCount;
        
        // update the price using our object global variable
        const priceAdditon = INGREDIENT_PRICES[type];
        const oldPrice = this.state.totalPrice;
        const newPrice = priceAdditon + oldPrice;
        
        // update the state with the new price and new ingredient added
        this.setState(
           {totalPrice: newPrice,
            ingredients: updatedIngredients} 
        );

        // update our order button
        this.updatePurchaseState(updatedIngredients);
    }

    // removes ingredient in addition to totalPrice
    removeIngredientHandler = (type) => 
    {
        // creat copy of ingredient
        let updatedIngredients = {
            ...this.state.ingredients
        };

        // create variables for ingredient count
        const oldCount = updatedIngredients[type];
        
        if (oldCount <= 0) // in a case where we have no ingredients
        {
            return;
        }

        const newCount = oldCount -1;

        // update the count of the chosen ingredient
        updatedIngredients[type] = newCount;

        // create variable for price
        const oldPrice = this.state.totalPrice;
        // update the price (subtract)
        const newPrice = oldPrice - INGREDIENT_PRICES[type];

        // update the state 
        this.setState(
            {ingredients: updatedIngredients,
            totalPrice: newPrice}
        );

        // update our order now button is clicked
        this.updatePurchaseState(updatedIngredients);

    }

    // handler for if the order now button is clicked
    purchaseHandler = () =>
    {
        this.setState({purchasing: true})
    }

    // this is if the person would like to get out of the purchase screen
    purchaseCancelHandler = () =>
    {
        this.setState ({purchasing: false})
    }

    purchaseContinueHandler = () =>
    {
        alert(' Working on the checkout page still, check back later :) ');
    }
    
    render()
    {
        // this will find out if we have no ingredients currently
        const disabledInfo = {
            ... this.state.ingredients
        };
        for (let key in disabledInfo)
        {
            disabledInfo[key] = disabledInfo[key] <=0; // check each value from the key {salad: 0} to see if it is 0
            // for each ingredient, we figure out if it true or not
            // so now each ingredient will be set to true or false
            // {salad: true} if there was no ingredients at that time 
        };

        return (
            <Auxilary>
                <Modal
                 show = {this.state.purchasing}
                 modalClosed = {this.purchaseCancelHandler}>
                    <OrderSummary 
                        ingredients = {this.state.ingredients}
                        purchaseCanceled = {this.purchaseCancelHandler}
                        purchasedContinued = {this.purchaseContinueHandler}
                        priceTotal = {this.state.totalPrice}/>  
                </Modal> 
                <Burger ingredients = {this.state.ingredients}/>
                <BuildControls 
                    ingredientAdded = {this.addIngredientHandler}
                    ingredientRemoved = {this.removeIngredientHandler}
                    disabled = {disabledInfo}
                    price = {this.state.totalPrice}
                    purchasable = {this.state.purchasable}
                    ordered = {this.purchaseHandler}/>
            </Auxilary>
        );
    }
}

export default BurgerBuilder;


// WEBPACK FOOTER //
// ./src/containers/BurgerBuilder/BurgerBuilder.js